export const NETWORKFILTERING_GETIPS_LOADING =
  'NETWORKFILTERING_GETIPS_LOADING';
export const NETWORKFILTERING_GETIPS_SUCCESS =
  'NETWORKFILTERING_GETIPS_SUCCESS';
export const NETWORKFILTERING_GETIPS_ERROR = 'NETWORKFILTERING_GETIPS_ERROR';

export const NETWORKFILTERING_GETENABLED_LOADING =
  'NETWORKFILTERING_GETENABLED_LOADING';
export const NETWORKFILTERING_GETENABLED_SUCCESS =
  'NETWORKFILTERING_GETENABLED_SUCCESS';
export const NETWORKFILTERING_GETENABLED_ERROR =
  'NETWORKFILTERING_GETENABLED_ERROR';

export const NETWORKFILTERING_SETENABLED_LOADING =
  'NETWORKFILTERING_SETENABLED_LOADING';
export const NETWORKFILTERING_SETENABLED_SUCCESS =
  'NETWORKFILTERING_SETENABLED_SUCCESS';
export const NETWORKFILTERING_SETENABLED_ERROR =
  'NETWORKFILTERING_SETENABLED_ERROR';

export const NETWORKFILTERING_POSTIP_LOADING =
  'NETWORKFILTERING_POSTIP_LOADING';
export const NETWORKFILTERING_POSTIP_SUCCESS =
  'NETWORKFILTERING_POSTIP_SUCCESS';
export const NETWORKFILTERING_POSTIP_ERROR = 'NETWORKFILTERING_POSTIP_ERROR';

export const NETWORKFILTERING_GETMYIP_LOADING =
  'NETWORKFILTERING_GETMYIP_LOADING';
export const NETWORKFILTERING_GETMYIP_SUCCESS =
  'NETWORKFILTERING_GETMYIP_SUCCESS';
export const NETWORKFILTERING_GETMYIP_ERROR = 'NETWORKFILTERING_GETMYIP_ERROR';

export const NETWORKFILTERING_POSTDELETEIP_LOADING =
  'NETWORKFILTERING_POSTDELETEIP_LOADING';
export const NETWORKFILTERING_POSTDELETEIP_SUCCESS =
  'NETWORKFILTERING_POSTDELETEIP_SUCCESS';
export const NETWORKFILTERING_POSTDELETEIP_ERROR =
  'NETWORKFILTERING_POSTDELETEIP_ERROR';

export const NETWORKFILTERING_GETMYIPVALID_LOADING =
  'NETWORKFILTERING_GETMYIPVALID_LOADING';
export const NETWORKFILTERING_GETMYIPVALID_SUCCESS =
  'NETWORKFILTERING_GETMYIPVALID_SUCCESS';
export const NETWORKFILTERING_GETMYIPVALID_ERROR =
  'NETWORKFILTERING_GETMYIPVALID_ERROR';



// WEBPACK FOOTER //
// ./src/pages/networkfiltering/state/types.js